import { ReactNode, FC, useEffect } from 'react';
import { Box, IconButton, Drawer as MuiDrawer, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useDrawer } from '@carcareers/contexts';

export interface DrawerProps {
  children?: ReactNode;
  title?: string;
  width?: number;
  action?: ReactNode;
}

export const Drawer: FC<DrawerProps> = ({ children, title, width, action }) => {
  const { open, setOpen, setWidth } = useDrawer();

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setWidth(width);
  }, [width, setWidth]);

  return (
    <MuiDrawer
      anchor="right"
      variant="persistent"
      open={open}
      slotProps={{
        paper: {
          sx: {
            maxWidth: width,
            width: '100%',
            container: 'drawer / inline-size',
            top: 'var(--app-header-height)',
            height: `calc(100vh - var(--app-header-height))`,
            backgroundColor: 'primary.main',
          },
        },
      }}
    >
      <Box
        sx={{
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="h3" color="primary.contrastText">
            {title}
          </Typography>
          {action}
        </Box>
        <IconButton
          onClick={handleClose}
          sx={{ color: 'primary.contrastText', '&:hover': { backgroundColor: 'primary.light' } }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          overflowY: 'auto',
          height: '100%',
          backgroundColor: 'background.paper',
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        }}
      >
        {children}
      </Box>
    </MuiDrawer>
  );
};
